import useRouteQuery from "../common/useRouteQuery";
import { useQuery } from "react-query";
import businessUserRepo from "../../API/LayoutApi/businessUser.repo";

function useBusinessUserList({
  pageRouteQuery = "page",
  businessIdRouteQuery = "business_id",
  emailRouteQuery = "email",
  phoneRouteQuery = "phone",
  searchRouteQuery = "search",
  isActiveRouteQuery = "is_active",
} = {}) {
  const [page, setPage] = useRouteQuery(1, pageRouteQuery, (v) => Number(v));
  const [businessId, setBusinessId] = useRouteQuery(
    "",
    businessIdRouteQuery,
    (v) => String(v)
  );
  const [email, setEmail] = useRouteQuery("", emailRouteQuery, (v) =>
    String(v)
  );
  const [phone, setPhone] = useRouteQuery("", phoneRouteQuery, (v) =>
    String(v)
  );
  const [search, setSearch] = useRouteQuery("", searchRouteQuery, (v) =>
    String(v)
  );
  const [isActive, setIsActive] = useRouteQuery("", isActiveRouteQuery, (v) =>
    String(v)
  );

  const { isLoading, isFetching, data, refetch } = useQuery({
    queryKey: [
      "business-users",
      businessId,
      page,
      email,
      phone,
      search,
      isActive,
    ],
    queryFn: () =>
      businessUserRepo.getBusinessUsers({
        page,
        perPage: 10,
        business_id: businessId ? businessId : undefined,
        email: email ? email : undefined,
        phone: phone ? phone : undefined,
        search: search ? search : undefined,
        is_active: isActive ? JSON.parse(isActive) : undefined,
      }),
    refetchOnWindowFocus: false,
  });

  return {
    page,
    setPage,
    businessId,
    setBusinessId,
    email,
    setEmail,
    phone,
    setPhone,
    search,
    setSearch,
    isActive,
    setIsActive,
    isLoading,
    isFetching,
    data,
    refetch,
  };
}

export default useBusinessUserList;
